import { PAT_TOGGLE_BTN, TPlayResultTypes, TWO_PT_TOGGLE_BTN } from '@/constants';
import { usePlayFlowState } from '@/stores/playFlow';
import { IConfirmationInput, IMachineContext, TColors, TPatEvents, TPlayResults, TTeamSide } from '@/types';
import { TPATPlayEvents } from '@/types/workflow/patMachine';
import { pushResultType } from './util';

export function extraPointPlayCompletedCtxUpdate(
  send: Function,
  context: Partial<IMachineContext>,
  nextStateInput: IConfirmationInput,
  playFlowState: ReturnType<typeof usePlayFlowState>,
  resultType: TPlayResultTypes
) {
  const driveDirection =
    playFlowState.teams.right === playFlowState.presentStateBasedOnCurrentMode.activeTeam
      ? TTeamSide.RIGHT
      : TTeamSide.LEFT;
  send(TPATPlayEvents.PAT_COMPLETED, {
    ctxUpdate: {
      currentPlay: {
        ...context.currentPlay,
        resultType: pushResultType(context, resultType),
        postPlayYardLine: 10,
        postPlaySide: driveDirection === TTeamSide.LEFT ? TTeamSide.RIGHT : TTeamSide.LEFT,
        driveDirection,
      },
    },
    nextStateInput,
  });
}

/**
 * add confirmation button for two point return and send to confirmation
 * @param send
 * @param nextStateInput
 * @param context
 * @param playFlowState
 */
export function handleXPReturnConfirmation(
  send: Function,
  nextStateInput: IConfirmationInput,
  context: Partial<IMachineContext>,
  playFlowState: ReturnType<typeof usePlayFlowState>
) {
  nextStateInput.toggleButton = {
    text: TPlayResults.TWO_PT_RETURN,
    value: TPlayResults.TWO_PT_RETURN,
    color: TColors.BLUE,
    isHorizontal: true,
    isToggle: true,
    toggleInitialValue: true,
  };
  nextStateInput.backTo = TPATPlayEvents.BACK_TO_XP_ATTEMPT;

  extraPointPlayCompletedCtxUpdate(send, context, nextStateInput, playFlowState, TPlayResultTypes.PAT_MISS);
}

/**
 * add confirmation button for extra point and send to confirmation
 * @param send
 * @param nextStateInput
 * @param payload
 * @param context
 * @param playFlowState
 */
export function handleXPConfirmation(
  send: Function,
  nextStateInput: IConfirmationInput,
  payload: any,
  context: Partial<IMachineContext>,
  playFlowState: ReturnType<typeof usePlayFlowState>
) {
  nextStateInput.toggleButton = PAT_TOGGLE_BTN;
  nextStateInput.toggleButton.toggleInitialValue = payload.value === TPatEvents.XP_MADE;
  nextStateInput.backTo = TPATPlayEvents.BACK_TO_XP_ATTEMPT;

  extraPointPlayCompletedCtxUpdate(
    send,
    context,
    nextStateInput,
    playFlowState,
    payload.value === TPatEvents.XP_MADE ? TPlayResultTypes.EXTRA_PT : TPlayResultTypes.PAT_MISS
  );
}

/**
 * add two point conversion btn and send to confirmation
 * @param send
 * @param payload
 * @param context
 * @param playFlowState
 */
export function handleTwoPtConfirmation(send: any, payload: any, context: any, playFlowState: any) {
  const nextStateInput: IConfirmationInput = {
    toggleButton: TWO_PT_TOGGLE_BTN,
  };
  nextStateInput.toggleButton.toggleInitialValue = payload.value === TPlayResults.TWO_PT_MADE;
  nextStateInput.backTo = TPATPlayEvents.BACK_TO_TWO_PT_ATTEMPT;

  extraPointPlayCompletedCtxUpdate(
    send,
    context,
    nextStateInput,
    playFlowState,
    payload.value === TPlayResults.TWO_PT_MADE ? TPlayResultTypes.CONVERSION_2PT : TPlayResultTypes.PAT_MISS
  );
}

/**
 * create one point saftey button and go toconfirmation
 * @param send
 * @param context
 * @param playFlowState
 */
export function handleOnePointSafteyConfirmation(send: any, context: any, playFlowState: any) {
  const nextStateInput: IConfirmationInput = {
    toggleButton: {
      text: TPlayResults.ONE_PT_SAFTEY,
      value: TPlayResults.ONE_PT_SAFTEY,
      color: TColors.RED,
      isHorizontal: true,
      isToggle: true,
      toggleInitialValue: true,
    },
  };

  nextStateInput.backTo = TPATPlayEvents.BACK_TO_TWO_PT_RETURN_ONE_PT_SAFTEY;

  extraPointPlayCompletedCtxUpdate(send, context, nextStateInput, playFlowState, TPlayResultTypes.SAFTEY_1PT);
}

/**
 * create one point saftey button and go toconfirmation
 * @param send
 * @param context
 * @param playFlowState
 */
export function handleTwoPointReturnConfirmation(send: any, context: any, playFlowState: any) {
  const nextStateInput: IConfirmationInput = {
    toggleButton: {
      text: TPlayResults.TWO_PT_RETURN,
      value: TPlayResults.TWO_PT_RETURN,
      color: TColors.BLUE,
      isHorizontal: true,
      isToggle: true,
      toggleInitialValue: true,
    },
  };

  nextStateInput.backTo = TPATPlayEvents.BACK_TO_TWO_PT_RETURN_ONE_PT_SAFTEY;
  extraPointPlayCompletedCtxUpdate(
    send,
    context,
    nextStateInput,
    playFlowState,
    TPlayResultTypes.TWO_PT_RETURN
  );
}
